<script lang="ts" setup>
type Props = {
  title: string;
  subtitle: string;
};
const props = defineProps<Props>();
</script>
<template>
  <div class="lg:grid lg:grid-cols-12">
    <div
      class="lg:col-start-2 lg:col-span-11 bg-primary-200 dark:bg-primary-500 lg:-mt-12 lg:pt-20 lg:pb-20 lg:-top-2 py-4 lg:p-0 flex flex-col min-h-full lg:min-h-auto h-full lg:h-auto"
    >
      <div
        class="flex justify-between flex-col h-full lg:h-auto lg:grid lg:grid-cols-12 px-4 lg:px-0"
      >
        <div class="lg:col-span-7 lg:col-start-2">
          <div
            class="relative flex flex-col gap-y-4 text-primary-900 dark:text-primary-100"
          >
            <h1
              class="text-5xl lg:text-8xl leading-16 lg:leading-24 font-urbanist font-bold"
            >
              {{ props.title }}
            </h1>
            <h2 class="text-2xl font-bold text-vshadow-sm shadow-secondary-900">
              {{ props.subtitle }}
            </h2>
          </div>
        </div>
        <div class="lg:col-span-3">
          <slot name="social" />
        </div>
      </div>
    </div>
  </div>
</template>
